import { ReactNode, useState } from 'react';
import classNames from 'classnames';
import styles from './contact-boxout.module.scss';
import Item from './item';
import ChevronDown from 'wa-storybook/components/general/icon/components/chevron-down';
import ComponentAnimation, {
  AnimationTypes,
} from 'wa-storybook/components/general/component-animation/component-animation';

export type HelpOption = {
  action: string | any;
  analyticsEvent?: () => void;
  hook: string;
  label: string;
  icon?: () => ReactNode;
  restrictions?: Array<string>;
  operator?: 'OR' | 'AND';
  isHrefAction?: boolean;
  additionalCheck?: () => void;
};

type Props = {
  items?: Array<HelpOption>;
  children?: ReactNode;
  withDropdown?: boolean;
  dropdownLabel?: string;
  className?: string;
  id: string;
};

const ContactBoxout = ({
  items,
  children,
  withDropdown,
  dropdownLabel,
  className,
  id,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdownOpen = () => setIsOpen(prev => !prev);

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.list}>
        {items?.map((item: HelpOption) => (
          <Item
            ariaRole='link'
            action={item.action}
            analyticsEvent={item.analyticsEvent}
            label={item.label}
            icon={item.icon}
            key={item.label}
            dataHook={item.hook || item.label}
          />
        ))}

        {withDropdown && (
          <Item
            action={toggleDropdownOpen}
            label={dropdownLabel}
            dataHook='dropdownToggle'
            icon={ChevronDown}
            flip={isOpen}
            key={'dropdown-label'}
            isDropdown
            ariaHasPopUp='listbox'
            ariaRole='button'
            id={id}
          />
        )}
      </div>

      {!!children && (
        <ComponentAnimation
          displayContentIf={(!!children && isOpen) || !withDropdown}
          type={AnimationTypes.EXPAND_DOWN_AND_FADE_IN}
          id='contact-boxout-content'
          className={styles.children}
        >
          {children}
        </ComponentAnimation>
      )}
    </div>
  );
};

export default ContactBoxout;
